// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Tooltip_Tooltip__5BXKW:hover .Tooltip_tooltipContainer__XMFtm {
  opacity: 1;
}
.Tooltip_Tooltip__5BXKW .Tooltip_tooltipContainer__XMFtm {
  text-align: center;
  font-size: 1.08rem;
}
@media only screen and (max-width: 768px) {
  .Tooltip_Tooltip__5BXKW .Tooltip_tooltipContainer__XMFtm {
    font-size: 0.84rem;
  }
}
.Tooltip_Tooltip__5BXKW .Tooltip_tooltipContainer__XMFtm {
  opacity: 0;
  width: fit-content;
  transition: opacity 0.55s ease-in-out;
}
.Tooltip_Tooltip__5BXKW .Tooltip_childrenContainer__yljym {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}`, "",{"version":3,"sources":["webpack://./src/components/Tooltip/Tooltip.module.scss"],"names":[],"mappings":"AAEE;EACE,UAAA;AADJ;AAKE;EACE,kBAAA;EACA,kBAAA;AAHJ;AAII;EAHF;IAII,kBAAA;EADJ;AACF;AAJE;EAME,UAAA;EACA,kBAAA;EACA,qCAAA;AACJ;AACE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;AACJ","sourcesContent":["@import 'src/assets/globalStyleElements.module';\n.Tooltip {\n  &:hover .tooltipContainer {\n    opacity: 1;\n  }\n  &:hover .childrenContainer {\n  }\n  .tooltipContainer {\n    text-align: center;\n    font-size: $globalFontSize * 0.9;\n    @media only screen and (max-width: 768px) {\n      font-size: $globalFontSize * 0.7;\n    }\n    opacity: 0;\n    width: fit-content;\n    transition: opacity 0.55s ease-in-out;\n  }\n  .childrenContainer {\n    display: flex;\n    flex-direction: row;\n    justify-content: center;\n    align-items: center;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"Tooltip": `Tooltip_Tooltip__5BXKW`,
	"tooltipContainer": `Tooltip_tooltipContainer__XMFtm`,
	"childrenContainer": `Tooltip_childrenContainer__yljym`
};
export default ___CSS_LOADER_EXPORT___;
